import { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router';
import { normalizeUsername } from '../../shared/events';
import { EventRow } from '../components/Feed';
import { useT } from '../lib/i18n';
import { session, useSession, type FeedRow } from '../lib/session';

const on = (v: string | null, d: boolean) => (v === null ? d : v === '1' || v === 'true');

/** Transparent, silent feed for OBS / TikTok Live Studio Browser Sources. */
export function Overlay() {
  const t = useT();
  const s = useSession();
  const [params] = useSearchParams();
  const username = normalizeUsername(params.get('u'));
  const size = Math.max(12, Math.min(40, Number(params.get('size')) || 18));
  const max = Math.max(1, Math.min(50, Number(params.get('max')) || 12));
  const allowed = useMemo(() => {
    const set = new Set<FeedRow['kind']>();
    if (on(params.get('chats'), true)) set.add('chat');
    if (on(params.get('gifts'), true)) set.add('gift');
    if (on(params.get('follows'), true)) set.add('follow');
    if (on(params.get('shares'), false)) set.add('share');
    if (on(params.get('likes'), false)) set.add('like');
    if (on(params.get('joins'), false)) set.add('join');
    return set;
  }, [params]);

  useEffect(() => {
    document.body.classList.add('overlay');
    if (username) session.start(username, { silent: true, retryForever: true, page: 'overlay' });
    return () => {
      document.body.classList.remove('overlay');
      session.stop();
    };
  }, [username]);

  const rows = s.feed.filter((r) => allowed.has(r.kind)).slice(-max);

  if (!username) {
    return (
      <div className="overlay-feed" style={{ color: '#fff', fontSize: 14 }}>
        Add ?u=tiktok_username to this URL.
      </div>
    );
  }

  return (
    <div className="overlay-feed">
      {s.status !== 'live' && s.message && (
        <div className="ev" style={{ color: '#fff', fontSize: 13 }}>
          {s.message}
        </div>
      )}
      {rows.map((r) => (
        <EventRow key={r.id} row={r} t={t} fontSize={size} />
      ))}
    </div>
  );
}
